import React, { useState } from 'react';
import classNames from 'classnames';
import { Icon } from 'ui';
import { useFeatureFlags } from 'hooks';
import QuestionAnalytics from './QuestionAnalytics';

const ElearningScore = ({
  questionData,
  content,
  status,
  state,
  score,
  totalSecondsTracked,
  canViewTimeSpent,
  id,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const hasQuestionAnalyticsFeature = useFeatureFlags([
    'readiness-enable-scorm-question-analytics',
  ]);
  const hasQuestionAnalytics =
    hasQuestionAnalyticsFeature &&
    Array.isArray(questionData) &&
    questionData.length > 0;

  const controlId = `questionAnalytics-${id}`;

  return (
    <>
      <tr>
        <td>
          {hasQuestionAnalytics && (
            <button
              type="button"
              className="TableCollapsible-button"
              onClick={() => setIsExpanded(!isExpanded)}
              aria-expanded={isExpanded}
              aria-controls={controlId}
              aria-label={t(
                'progress.report_card.elearning.question_analytics',
              )}
            >
              <Icon
                name={isExpanded ? 'caret_down' : 'caret_right'}
                className="TableCollapsible-toggle"
                aria-label={t('progress.report_card.elearning.toggle_question')}
              />
            </button>
          )}
        </td>
        <td className="DataTable-name wide">{content}</td>
        <td>{status}</td>
        <td
          className={classNames({
            'data--blank': state === 'Unknown',
          })}
        >
          {state !== 'Unknown' ? state : 'N/A'}
        </td>
        <td
          className={classNames({
            'data--blank': !score,
          })}
        >
          {score ? `${score * 100}%` : 'N/A'}
        </td>
        {canViewTimeSpent && <td>{totalSecondsTracked}</td>}
      </tr>
      {hasQuestionAnalytics && isExpanded && (
        <tr className="QuestionAnalytics-row">
          <td />
          <QuestionAnalytics id={controlId} questionData={questionData} />
        </tr>
      )}
    </>
  );
};

export default ElearningScore;
